import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-383e12fa"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "wallet-card"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "deposit"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "price"
}, "USD", -1));

const _hoisted_5 = {
  class: "num"
}; //defineEmits, , ref
// import { useI18n } from "vue-i18n"
// const { t } = useI18n()

export default {
  __name: 'WalletCard',
  props: {
    balanceShow: {
      type: Boolean,
      default: true
    },
    actions: {
      type: Array,
      default: () => []
    },
    total: {
      type: String,
      default: '0.00000'
    }
  },

  setup(__props) {
    const props = __props; // const emit = defineEmits(['history', 'menuSelect'])
    // const showPopover = ref(false)

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString(props.total), 1)]), _renderSlot(_ctx.$slots, "default")])]);
    };
  }

};